import React from "react";
import {
  WorkflowConditionOperator,
  WorkflowConditionType,
} from "../../../../types";
import StatusInConditionEditor from "./StatusInConditionEditor";
import { ConditionEditorProps } from "./types";

type ConditionEditorKey =
  `${WorkflowConditionType}:${WorkflowConditionOperator}`;

type ConditionEditorComponent = React.ComponentType<ConditionEditorProps>;

const conditionEditorRepository: Partial<
  Record<ConditionEditorKey, ConditionEditorComponent>
> = {
  "status_id:in": StatusInConditionEditor,
};

/**
 * Returns the custom editor registered for a condition type and operator.
 */
export const getConditionEditor = (
  type: WorkflowConditionType,
  operator: WorkflowConditionOperator,
): ConditionEditorComponent | undefined =>
  conditionEditorRepository[`${type}:${operator}`];
